import React from 'react';
import Foundation from '../components/Foundation';

const FoundationPage = () => {
  return <Foundation />;
};

export default FoundationPage;

